<template>

  <div id="topSelect">
    <div v-show="openDrawer" id="mubanku">
      <p>模板库</p>
      <a @click="toggle(false)">收起</a>
    </div>
    <div v-show="!openDrawer" @click="toggle(true)" id="zhankai">
      模板库
    </div>
    <div id="mubancontent">
      <dl v-show="openDrawer" class="baojialabel" v-for="(x, xin) in madata" :key="xin">
        <dt>{{ xin }}</dt>
        <dd v-for="(y, yin) in x" :key="yin">

          <Checkbox v-model="y.select" @on-change="change(y, yin)">{{
            zidian[yin] }}</Checkbox>
        </dd>
      </dl>
    </div>

  </div>
</template>
<script>
import modelData from "./modelData";
export default {
  props: ["data"],
  data() {
    return {
      openDrawer: true,

      madata: {
        中港运输类: {
          danjia: { select: false },
          danjia2: { select: false },
          pinche: { select: false },
          zhuanche: { select: false },
          zhuanche2: { select: false },
        },
        派送类: {
          shouHuoSongHuo: { select: false },
          kuli: { select: false },
        },
        中转装卸: {
          zhuangXie: { select: false },
          zhuangXie2: { select: false },
          guoBan: { select: false },
          //kuli: { label: '苦力类', select: false },
        },
        其他类: { baoguan: { label: '报关类', select: false }, other: { label: '其他类', select: false }, }
      },
      zidian: modelData.zidian
    };
  },
  methods: {
    change(v, index) {
      this.$emit("on-change", v, index);
    },
    ff() {
      var mydata = this.madata;
      for (const i in mydata) {
        for (const j in mydata[i]) {
          mydata[i][j].select = this.data[j].select
        }
      }

    },
    selectModel() {
      this.openDrawer = true;
      this.ff();
    },
    toggle(v) {
      this.openDrawer = v;
      this.$emit('now', this.openDrawer)
    }
  },
  mounted() {
    this.ff()
  },
  watch: {
    data() {
      this.ff()
    },
  },
};
</script>
<style>
#topSelect {
  height: 100%;
}

#topSelect #zhankai {
  position: fixed;
  width: 20px;
  left: 0px;
  top: 200px;
  z-index: 9999;
  background: red;
  color: #fff;
  cursor: pointer;
  padding: 4px;
  border-radius: 0 4px 4px 0;
}

#mubanku {
  padding: 4px 10px;
  background: #c9ddf0;
  display: flex;
  margin-bottom: 10px;
}
#mubancontent{
  height: calc(100% - 50px);
  overflow: auto;
}
#mubanku p {
  margin-right: auto;
}

.baojialabel {
  margin-bottom: 20px;
}

.baojialabel dt {
  font-size: 18px;
}

.baojialabel dd {
  padding: 5px 0;
}
</style>


// WEBPACK FOOTER //
// src/components/wuliu/kehu/baojia/topSelect.vue